import { ApiUtility } from "./ApiUtility";

class AudioPlayerService {
  route = "/posts";

  getAudioById = (id: string, type: string) => {
    let finalId = id;

    // Check if id contains 'slug' (or 'slub' if you meant that literally)
    if (id.includes("slug") || id.includes("slub")) {
      finalId = encodeURIComponent(id);
    }

    const lang = localStorage.getItem("lan") ?? "hindi";

    if (type === "DailySatsang") {
      const url = `/api/${type}/GetById`;
      return ApiUtility.post(url, { id: finalId, lang }, "application/json");
    }
    else {
      return this.getAudiosById(id, type);
    }
  }

  getAudiosById = (id: string, type: string) => {

    let finalId = id;

    // Check if id contains 'slug' (or 'slub' if you meant that literally)
    if (id.includes("slug") || id.includes("slub")) {
      finalId = encodeURIComponent(id);
    }

    const url = `/api/${type}/${finalId}?lang=${localStorage.getItem("lan")}`;

    return ApiUtility.get(url);
  };

  getAudiosList = (
    lang: string,
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean,
    type: string,
    isOther?: boolean
  ) => {
    return ApiUtility.get(
      "/api/" +
      type +
      "?lang=" +
      lang +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&authorId=" +
      authorId +
      "&search=" +
      search +
      "&sort=" +
      sort +
      "&audioLangauge=" +
      langId +
      "&isSpecial=" +
      isSpecial +
      "&isOther=" +
      isOther
    );
  };

  getlyrics = (type: string, id: any) => {
    return ApiUtility.getResponse(
      "/api/" + type + "/" + id + "/lyrics"
    );
  }
}

export default new AudioPlayerService();